var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00012 10.2001L2.50012 6.70007C2.11012 6.31007 1.49012 6.31007 1.10012 6.70007C0.710117 7.09007 0.710117 7.71007 1.10012 8.10007L5.29012 12.2901C5.68012 12.6801 6.31012 12.6801 6.70012 12.2901L17.3001 1.70007C17.6901 1.31007 17.6901 0.690068 17.3001 0.300068C16.9101 -0.0899316 16.2901 -0.0899316 15.9001 0.300068L6.00012 10.2001Z",
    fill: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMDAwMTIgMTAuMjAwMUwyLjUwMDEyIDYuNzAwMDdDMi4xMTAxMiA2LjMxMDA3IDEuNDkwMTIgNi4zMTAwNyAxLjEwMDEyIDYuNzAwMDdDMC43MTAxMTcgNy4wOTAwNyAwLjcxMDExNyA3LjcxMDA3IDEuMTAwMTIgOC4xMDAwN0w1LjI5MDEyIDEyLjI5MDFDNS42ODAxMiAxMi42ODAxIDYuMzEwMTIgMTIuNjgwMSA2LjcwMDEyIDEyLjI5MDFMMTcuMzAwMSAxLjcwMDA3QzE3LjY5MDEgMS4zMTAwNyAxNy42OTAxIDAuNjkwMDY4IDE3LjMwMDEgMC4zMDAwNjhDMTYuOTEwMSAtMC4wODk5MzE2IDE2LjI5MDEgLTAuMDg5OTMxNiAxNS45MDAxIDAuMzAwMDY4TDYuMDAwMTIgMTAuMjAwMVoiIGZpbGw9IiMxQTFBMUEiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };